<template>
  <div>
    <div class="das_top_cont">
      <div class="history_box" v-if="DeleteAccount">
        <div class="accountright_cont_box">
          <div
            class="flex_center_between_box account-left-box"
            style="align-items: center"
          >
            <div>
              <div
                :class="
                  imgedit
                    ? 'account-left flex_center_between_box'
                    : ' flex_center_between_box'
                "
              >

                <div class="postiverelatibve"  v-if="imageUrl">
                   <div class="avatar"> 
                    <img :src="imageUrl" v-if="imageUrl" class="avatar" />
                    <div class="edit_con">
                      <svg
                        @click="imgedit = !imgedit"
                        t="1730092885407"
                        class="icon edit_con_icon"
                        viewBox="0 0 1024 1024"
                        version="1.1"
                        xmlns="http://www.w3.org/2000/svg"
                        p-id="5912"
                        xmlns:xlink="http://www.w3.org/1999/xlink"
                      >
                        <path
                          d="M769.824 291.542L666.519 188.237c-15.802-15.802-41.421-15.799-57.224 0l-361.94 361.94c-12.357 12.358-11.885 12.825-11.889 39.389-0.005 132.545 0.064 132.965 0.064 132.965s0.42 0.07 132.969 0.065c26.561 0 27.027 0.468 39.39-11.891L769.824 348.77c15.805-15.802 15.809-41.421 0-57.228zM394.826 664.313c-14.95 14.949-15.478 14.416-45.967 14.416-69.291 0-69.404-0.117-69.404-0.117s-0.121-0.114-0.121-69.409c0-30.489-0.529-31.017 14.416-45.963l240.425-240.425 101.071 101.076-240.42 240.422z m270.149-270.151L563.903 293.086l46.567-46.566c27.437-27.437 27.852-27.023 54.879 0.006l46.187 46.187c27.033 27.026 27.447 27.442 0.007 54.885l-46.568 46.564zM811.435 718.375H637.664c-11.609 0-21.02-9.411-21.02-21.021 0-11.611 9.41-21.021 21.02-21.021h173.771c11.612 0 21.021 9.41 21.021 21.021 0 11.61-9.409 21.021-21.021 21.021zM811.435 847.612H256.487c-11.612 0-21.021-9.411-21.021-21.021 0-11.609 9.408-21.021 21.021-21.021h554.947c11.612 0 21.021 9.411 21.021 21.021 0.001 11.61-9.408 21.021-21.02 21.021z"
                          fill="#ffffff"
                          p-id="5913"
                        ></path>
                      </svg>
                    </div>
                  </div>
                </div>

                <div class="postiverelatibve" v-else >
                  <div class="avatar avatartex">
                    {{ userinfo?.userInfo?.firstName.substring(0, 1) }}
                    <div class="edit_con">
                      <svg
                        @click="imgedit = !imgedit"
                        t="1730092885407"
                        class="icon edit_con_icon"
                        viewBox="0 0 1024 1024"
                        version="1.1"
                        xmlns="http://www.w3.org/2000/svg"
                        p-id="5912"
                        xmlns:xlink="http://www.w3.org/1999/xlink"
                      >
                        <path
                          d="M769.824 291.542L666.519 188.237c-15.802-15.802-41.421-15.799-57.224 0l-361.94 361.94c-12.357 12.358-11.885 12.825-11.889 39.389-0.005 132.545 0.064 132.965 0.064 132.965s0.42 0.07 132.969 0.065c26.561 0 27.027 0.468 39.39-11.891L769.824 348.77c15.805-15.802 15.809-41.421 0-57.228zM394.826 664.313c-14.95 14.949-15.478 14.416-45.967 14.416-69.291 0-69.404-0.117-69.404-0.117s-0.121-0.114-0.121-69.409c0-30.489-0.529-31.017 14.416-45.963l240.425-240.425 101.071 101.076-240.42 240.422z m270.149-270.151L563.903 293.086l46.567-46.566c27.437-27.437 27.852-27.023 54.879 0.006l46.187 46.187c27.033 27.026 27.447 27.442 0.007 54.885l-46.568 46.564zM811.435 718.375H637.664c-11.609 0-21.02-9.411-21.02-21.021 0-11.611 9.41-21.021 21.02-21.021h173.771c11.612 0 21.021 9.41 21.021 21.021 0 11.61-9.409 21.021-21.021 21.021zM811.435 847.612H256.487c-11.612 0-21.021-9.411-21.021-21.021 0-11.609 9.408-21.021 21.021-21.021h554.947c11.612 0 21.021 9.411 21.021 21.021 0.001 11.61-9.408 21.021-21.02 21.021z"
                          fill="#ffffff"
                          p-id="5913"
                        ></path>
                      </svg>
                    </div>
                  </div>
                </div>
                <div class="account-left-right account_base">
                  <h3>
                    {{ userinfo?.userInfo?.firstName
                    }}{{ userinfo?.userInfo?.lastName }}
                  </h3>
                  <h4 v-if="userType == 1">
                    {{ $t("navigationBar.IndivdualAccount") }}
                  </h4>
                  <h4 v-else>
                    {{ $t("navigationBar.GroupAccount") }}
                  </h4>
                  <div class="account-left-right-time margin-top20">
                    {{ $t("MyAccount.Registrationtime") }}:
                    {{ userinfo?.userInfo?.createTime }}
                  </div>
                </div>
                <div
                  v-if="userType != 1"
                  class="account-left-right role_company"
                >
                  <h3>{{ userinfo?.companyInfo?.companyName }}</h3>
                  <h4 v-if="userType == 3">
                    {{ $t("MyAccount.Role") }}:
                    {{ $t("MyAccount.Administrator") }}
                  </h4>
                  <h4 v-if="userType == 2">
                    {{ $t("MyAccount.Role") }}:
                    {{ $t("MyAccount.Enterpriseusers") }}
                  </h4>
                </div>
              </div>
              <div class="account_btn" v-if="imgedit">
                <el-upload
                  class="avatar-uploader account_btn margin-right20"
                  action=""
                  :show-file-list="false"
                  :auto-upload="false"
                  :on-preview="handlePictureCardPreview"
                  :on-success="handleAvatarSuccess"
                  :on-change="imgchange"
                  :before-upload="beforeAvatarUpload"
                >
                  <el-button
                    class="btn_blue flex_center logout_btn account_btn"
                    >{{ $t("MyAccount.EditImage") }}</el-button
                  >
                </el-upload>
                <button
                  @click="Deletapicture"
                  class="flex_center logout_btn"
                  :class="imageUrl == '' ? 'btn_blue btn_eee ' : 'btn_blue'"
                  :disabled="imageUrl == ''"
                >
                  {{ $t("MyAccount.DeleteImage") }}
                </button>
              </div>
            </div>

            <div class="account_btn">
              <div style="display: flex">
                <button
                  class="btn_blue flex_center logout_btn margin-right20"
                  @click="SubmitLoginOut"
                >
                  {{ $t("MyAccount.SignOut") }}
                </button>
                <button
                  class="btn_blue flex_center btn_eee del_btn"
                  @click="DeleteAccountedlog()"
                >
                  {{ $t("MyAccount.DeleteAccount") }}
                </button>
              </div>
            </div>
          </div>
          <div class="flex_center_between_box content-center account_form_item">
            <div class="sel_box">
              <h4>{{ $t("MyAccount.AccountID") }}</h4>
              <el-input
                v-model="Accountid"
                :disabled="EditOne"
                :placeholder="$t('MyAccount.Enteranewaddress')"
                @focus="errFlag = false"
              >
              </el-input>
            </div>

            <div class="account_btn">
              <button
                class="btn_blue flex_center btn_eee change_btn"
                v-if="EditOne"
                @click="ChangeAccount()"
              >
                {{ $t("MyAccount.Change") }}
              </button>
              <div v-else style="display: flex">
                <button
                  class="btn_blue flex_center change_btn_mr10"
                  @click="ChangeAccountid()"
                >
                  {{ $t("MyAccount.Save") }}
                </button>
                <button
                  class="btn_blue flex_center change_btn_gray"
                  @click="ChangeAccount()"
                >
                  {{ $t("MyAccount.Cancel") }}
                </button>
              </div>
            </div>
          </div>
          <div
            class="flex_center_between_box content-center account_form_itemA"
            v-if="!EditOne"
          >
            <div class="sel_box">
              <el-input
                v-model="Emailcode"
                class="send_code_mar"
                :placeholder="$t('MyAccount.EnterVerificationCode')"
                maxlength="20"
              ></el-input>
              <span
                class="send_txt"
                v-show="setTimeForFlag"
                @click="sendCodeForgot"
              >
                {{ $t("MyAccount.SendverificationCode") }}
              </span>
              <div class="send_time" v-show="!setTimeForFlag">
                {{ setTimeFor }}s
              </div>
            </div>
          </div>
          <div class="flex_center_between_box content-center account_form_item">
            <div class="sel_box">
              <h4>{{ $t("MyAccount.Password") }}</h4>
              <div class="information-content password_item_account">
                <div class="computer_right_cont_box" style="width: 100%">
                  <el-input
                    v-model="password"
                    :disabled="EditTwo"
                    :type="type"
                    :placeholder="$t('MyAccount.Originalpassword')"
                    @focus="errFlag = false"
                    maxlength="20"
                  >
                    <i
                      slot="suffix"
                      class="icon_watch"
                      :class="inputType ? 'icon_watchun' : 'icon_watchon'"
                      @click="inputType = !inputType"
                    ></i>
                  </el-input>
                </div>
              </div>
            </div>

            <div class="account_btn">
              <button
                class="btn_blue flex_center btn_eee change_btn"
                v-if="EditTwo"
                @click="
                  EditTwo = !EditTwo;
                  PasswordChange = true;
                "
              >
                {{ $t("MyAccount.Change") }}
              </button>
              <div v-else style="display: flex">
                <button
                  class="btn_blue flex_center change_btn_mr10"
                  style="margin-right: 10px"
                  @click="ChangePassword()"
                >
                  {{ $t("MyAccount.Save") }}
                </button>
                <button
                  class="btn_blue flex_center change_btn_gray"
                  @click="changepass()"
                >
                  {{ $t("MyAccount.Cancel") }}
                </button>
              </div>
            </div>
          </div>
          <div v-if="PasswordChange">
            <div
              class="flex_center_between_box content-center account_form_itemA"
            >
              <div class="sel_box">
                <div class="information-content password_item_account">
                  <div class="computer_right_cont_box" style="width: 100%">
                    <el-input
                      v-model="passwordtwo"
                      :type="inputTypetwo ? 'text' : 'password'"
                      :placeholder="$t('MyAccount.Newpassword')"
                      @focus="errFlag = false"
                      maxlength="20"
                    >
                      <i
                        slot="suffix"
                        class="icon_watch"
                        :class="inputTypetwo ? 'icon_watchun' : 'icon_watchon'"
                        @click="inputTypetwo = !inputTypetwo"
                      ></i>
                    </el-input>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="flex_center_between_box content-center account_form_itemA"
            >
              <div class="sel_box">
                <div class="information-content password_item_account">
                  <div class="computer_right_cont_box" style="width: 100%">
                    <el-input
                      v-model="passwordtree"
                      :type="inputTypetree ? 'text' : 'password'"
                      :placeholder="$t('MyAccount.Confirmnewpassword')"
                      @focus="errFlag = false"
                      maxlength="20"
                    >
                      <i
                        slot="suffix"
                        class="icon_watch"
                        :class="inputTypetree ? 'icon_watchun' : 'icon_watchon'"
                        @click="inputTypetree = !inputTypetree"
                      ></i>
                    </el-input>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div>
            <div
              class="flex_center_between_box content-center account_form_item"
            >
              <div class="sel_box">
                <h4>{{ $t("MyAccount.AccountOwnership") }}</h4>
                <div v-if="EditTree" class="AccountOwnership margin-top20">
                  <span v-if="userType == 1">
                    {{ $t("MyAccount.IndividualAccount") }}</span
                  >
                  <span v-else> {{ $t("MyAccount.GroupAccount") }}</span>
                </div>
                <div v-else class="margin-top20">
                  <div class="flex_box">
                    <el-radio
                      v-model="radio"
                      :disabled="userType == 3 || userType == 2"
                      label="1"
                    >
                      {{ $t("MyAccount.IndividualAccount") }}</el-radio
                    >
                    <el-radio v-model="radio" label="2">
                      {{ $t("MyAccount.GroupAccount") }}</el-radio
                    >
                  </div>
                </div>
              </div>

              <div class="account_btn">
                <button
                  class="btn_blue flex_center btn_eee change_btn"
                  v-if="EditTree"
                  @click="Changauthentication()"
                >
                  {{ $t("MyAccount.Change") }}
                </button>
                <div v-else style="display: flex">
                  <button
                    class="btn_blue flex_center change_btn_mr10"
                    :class="userType == 1 ? 'btn_blue' : 'btn_eee'"
                    :disabled="userType != 1"
                    style="margin-right: 10px"
                    @click="ChangeOwnership()"
                  >
                    {{ $t("MyAccount.Save") }}
                  </button>
                  <button
                    class="btn_blue flex_center change_btn_gray"
                    @click="EditTree = !EditTree"
                  >
                    {{ $t("MyAccount.Cancel") }}
                  </button>
                </div>
              </div>
            </div>
            <div v-if="!EditTree" class="margin-top20">
              <div class="his_sel_box" v-if="radio == '1'">
                <div class="information-content">
                  <div class="sel_box computer_right_cont_box">
                    <el-input
                      class="inline-input"
                      clearable
                      v-model="Peoplecertification.companyName"
                      :placeholder="$t('MyAccount.Organizationname')"
                    ></el-input>
                  </div>
                  <div class="sel_box computer_right_cont_box">
                    <el-input
                      class="inline-input"
                      clearable
                      v-model="Peoplecertification.firstName"
                      :placeholder="$t('MyAccount.FirstName')"
                    ></el-input>
                  </div>
                </div>
                <div class="information-content account_form_itemA">
                  <div class="sel_box computer_right_cont_box">
                    <el-select
                      style="width: 100%"
                      filterable
                      v-model="Peoplecertification.countryCode"
                      :placeholder="$t('MyAccount.CountryRegion')"
                      class="fin_top_sel"
                      @change="changeCountry"
                    >
                      <el-option
                        v-for="item in countryOptions"
                        :key="item.countryCode"
                        :label="item.nameEn"
                        :value="item.countryCode"
                      ></el-option>
                    </el-select>
                  </div>
                  <div class="sel_box computer_right_cont_box">
                    <el-input
                      class="inline-input"
                      clearable
                      v-model="Peoplecertification.lastName"
                      :placeholder="$t('MyAccount.LastName')"
                    ></el-input>
                  </div>
                </div>
                <div class="information-content account_form_itemA">
                  <div class="sel_box computer_right_cont_box">
                    <el-input
                      class="inline-input"
                      clearable
                      v-model="Peoplecertification.address1"
                      :placeholder="$t('MyAccount.Address')"
                    ></el-input>
                  </div>
                  <div class="sel_box computer_right_cont_box">
                    <el-input
                      class="inline-input"
                      clearable
                      v-model="Peoplecertification.phoneNumber"
                      :placeholder="$t('MyAccount.PhoneNumber')"
                    ></el-input>
                  </div>
                </div>
                <div class="information-content account_form_itemA">
                  <div class="sel_box computer_right_cont_box">
                    <el-input
                      class="inline-input"
                      clearable
                      v-model="Peoplecertification.city"
                      :placeholder="$t('MyAccount.City')"
                    ></el-input>
                  </div>
                  <div class="sel_box computer_right_cont_box">
                    <el-input
                      class="inline-input"
                      clearable
                      v-model="Peoplecertification.email"
                      :placeholder="$t('MyAccount.Email')"
                    ></el-input>
                  </div>
                </div>
                <div class="information-content account_form_itemA">
                  <div class="sel_box computer_right_cont_box">
                    <el-input
                      class="inline-input"
                      clearable
                      v-model="Peoplecertification.zipCode"
                      :placeholder="$t('MyAccount.ZipCode')"
                    ></el-input>
                  </div>
                </div>
              </div>
              <div class="his_sel_box" v-else>
                <div class="information-content">
                  <div class="sel_box computer_right_cont_box">
                    <el-input
                      class="inline-input"
                      :disabled="userType != 1"
                      clearable
                      v-model="Enterprisecertification.companyName"
                      :placeholder="$t('MyAccount.Organizationname')"
                    ></el-input>
                  </div>
                  <div class="sel_box computer_right_cont_box">
                    <el-input
                      class="inline-input"
                      :disabled="userType != 1"
                      clearable
                      v-model="Enterprisecertification.firstName"
                      :placeholder="$t('MyAccount.FirstName')"
                    ></el-input>
                  </div>
                </div>
                <div class="information-content account_form_itemA">
                  <div class="sel_box computer_right_cont_box">
                    <el-select
                      style="width: 100%"
                      :disabled="userType != 1"
                      filterable
                      v-model="Enterprisecertification.countryCode"
                      :placeholder="$t('MyAccount.CountryRegion')"
                      class="fin_top_sel"
                      @change="changeCountry"
                    >
                      <el-option
                        v-for="item in countryOptions"
                        :key="item.countryCode"
                        :label="item.nameEn"
                        :value="item.countryCode"
                      ></el-option>
                    </el-select>
                  </div>
                  <div class="sel_box computer_right_cont_box">
                    <el-input
                      class="inline-input"
                      :disabled="userType != 1"
                      clearable
                      v-model="Enterprisecertification.lastName"
                      :placeholder="$t('MyAccount.LastName')"
                    ></el-input>
                  </div>
                </div>
                <div class="information-content account_form_itemA">
                  <div class="sel_box computer_right_cont_box">
                    <el-input
                      class="inline-input"
                      :disabled="userType != 1"
                      clearable
                      v-model="Enterprisecertification.address1"
                      :placeholder="$t('MyAccount.Address')"
                    ></el-input>
                  </div>
                  <div class="sel_box computer_right_cont_box">
                    <el-input
                      class="inline-input"
                      :disabled="userType != 1"
                      clearable
                      v-model="Enterprisecertification.phoneNumber"
                      :placeholder="$t('MyAccount.PhoneNumber')"
                    ></el-input>
                  </div>
                </div>
                <div class="information-content account_form_itemA">
                  <div class="sel_box computer_right_cont_box">
                    <el-input
                      class="inline-input"
                      :disabled="userType != 1"
                      clearable
                      v-model="Enterprisecertification.city"
                      :placeholder="$t('MyAccount.City')"
                    ></el-input>
                  </div>
                  <div class="sel_box computer_right_cont_box">
                    <el-input
                      class="inline-input"
                      :disabled="userType != 1"
                      clearable
                      v-model="Enterprisecertification.email"
                      :placeholder="$t('MyAccount.Email')"
                    ></el-input>
                  </div>
                </div>
                <div class="information-content account_form_itemA">
                  <div class="sel_box computer_right_cont_box">
                    <el-input
                      class="inline-input"
                      :disabled="userType != 1"
                      clearable
                      v-model="Enterprisecertification.zipCode"
                      :placeholder="$t('MyAccount.ZipCode')"
                    ></el-input>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="accountright_cont_box box2">
          <ul class="ul-tab">
            <li>
              <h4 class="ul-tab-title">{{ $t("MyAccount.LastLogin") }}</h4>
              <h4 class="ul-tab-text">{{ lastLogDur }}</h4>
            </li>
            <li>
              <h4 class="ul-tab-title">{{ $t("MyAccount.RecentLogin") }}</h4>
              <h4 class="ul-tab-text">{{ recentLoginTime }}</h4>
            </li>
            <li>
              <h4 class="ul-tab-title">
                {{ $t("MyAccount.AverageLoginTime") }}
              </h4>
              <h4 class="ul-tab-text">{{ averageLoginTime }}</h4>
            </li>
            <li>
              <h4 class="ul-tab-title">
                {{ $t("MyAccount.TotalLoginAttempts") }}
              </h4>
              <h4 class="ul-tab-text">{{ totalLogins }}</h4>
            </li>
          </ul>
        </div>
        <div class="accountright_cont_box margin-top10">
          <ul class="flex_center_star">
            <div class="ul-tab-left">
              <div class="ul-tab-left-rili">
                <div class="rili-top">
                  <i
                    class="rili-top-left flex_center"
                    @click="YearNum--, Active(AvtiveValue, ActiveIndex)"
                    ><svg
                      t="1726039901603"
                      class="icon iconleft"
                      viewBox="0 0 1024 1024"
                      version="1.1"
                      xmlns="http://www.w3.org/2000/svg"
                      p-id="5401"
                      data-spm-anchor-id="a313x.manage_type_myprojects.0.i2.4d7f3a819Fvsz5"
                    >
                      <path
                        d="M705 923c-6.4 0-12.8-2.4-17.7-7.3l-386-386c-9.8-9.8-9.8-25.6 0-35.4l386-386c9.8-9.8 25.6-9.8 35.4 0 9.8 9.8 9.8 25.6 0 35.4L354.4 512l368.3 368.3c9.8 9.8 9.8 25.6 0 35.4-4.9 4.9-11.3 7.3-17.7 7.3z"
                        fill="#1A2332"
                        p-id="5402"
                      ></path>
                    </svg>
                  </i>
                  <span
                    ><svg
                      t="1726040026069"
                      class="icon iconrili"
                      viewBox="0 0 1024 1024"
                      version="1.1"
                      xmlns="http://www.w3.org/2000/svg"
                      p-id="6007"
                    >
                      <path
                        d="M935.812877 88.243078h-87.685776V29.784188a29.226886 29.226886 0 1 0-58.453771 0v58.45889H234.331789V29.784188a29.226886 29.226886 0 1 0-58.453771 0v58.45889H88.187123C39.762336 88.243078 0.501347 127.498948 0.501347 175.923735v759.945098c0 48.429907 39.260989 87.685776 87.685776 87.685776h847.625754c48.424787 0 87.685776-39.260989 87.685776-87.685776V175.928854c0-48.424787-39.260989-87.685776-87.685776-87.685776z m29.226886 847.625755a29.232005 29.232005 0 0 1-29.226886 29.232005H88.187123a29.232005 29.232005 0 0 1-29.226886-29.232005V351.300406h906.079526v584.568427z m0-643.027317H58.960237V175.928854a29.226886 29.226886 0 0 1 29.226886-29.226885h87.685776v29.226885a29.226886 29.226886 0 1 0 58.453771 0v-29.226885h555.341541v29.226885a29.226886 29.226886 0 1 0 58.453771 0v-29.226885h87.685776a29.226886 29.226886 0 0 1 29.226885 29.226885V292.841516z"
                        p-id="6008"
                        fill="#1A2332"
                      ></path>
                      <path
                        d="M512 526.671958c24.179117 0 43.842888-19.663771 43.842888-43.842888A43.842888 43.842888 0 0 0 512 438.986182a43.807052 43.807052 0 0 0-43.842888 43.842888c0 24.173998 19.597218 43.842888 43.842888 43.842888zM745.825323 877.409942c24.184237 0 43.842888-19.663771 43.842888-43.842888a43.842888 43.842888 0 0 0-43.842888-43.842888 43.801932 43.801932 0 0 0-43.842888 43.842888c0.005119 24.179117 19.602337 43.842888 43.842888 43.842888zM512 702.03839c24.179117 0 43.842888-19.658651 43.842888-43.842888 0-24.240551-19.663771-43.837769-43.842888-43.837768a43.801932 43.801932 0 0 0-43.842888 43.837768A43.842888 43.842888 0 0 0 512 702.03839zM745.825323 526.671958c24.184237 0 43.842888-19.663771 43.842888-43.842888a43.842888 43.842888 0 0 0-43.842888-43.842888 43.807052 43.807052 0 0 0-43.842888 43.842888c0.005119 24.173998 19.602337 43.842888 43.842888 43.842888zM745.825323 702.03839c24.184237 0 43.842888-19.658651 43.842888-43.842888 0-24.240551-19.663771-43.837769-43.842888-43.837768a43.801932 43.801932 0 0 0-43.842888 43.837768c0.005119 24.184237 19.602337 43.842888 43.842888 43.842888zM512 877.409942c24.179117 0 43.842888-19.663771 43.842888-43.842888a43.842888 43.842888 0 0 0-43.842888-43.842888 43.801932 43.801932 0 0 0-43.842888 43.842888 43.842888 43.842888 0 0 0 43.842888 43.842888zM278.174677 877.409942c24.179117 0 43.842888-19.663771 43.842888-43.842888a43.842888 43.842888 0 0 0-43.842888-43.842888 43.801932 43.801932 0 0 0-43.842888 43.842888 43.842888 43.842888 0 0 0 43.842888 43.842888zM278.174677 702.03839c24.179117 0 43.842888-19.658651 43.842888-43.842888 0-24.240551-19.663771-43.837769-43.842888-43.837768a43.801932 43.801932 0 0 0-43.842888 43.837768 43.842888 43.842888 0 0 0 43.842888 43.842888zM278.174677 526.671958c24.179117 0 43.842888-19.663771 43.842888-43.842888a43.842888 43.842888 0 0 0-43.842888-43.842888 43.807052 43.807052 0 0 0-43.842888 43.842888c0 24.173998 19.597218 43.842888 43.842888 43.842888z"
                        p-id="6009"
                        fill="#1A2332"
                      ></path>
                    </svg>
                    {{ YearNum }}
                  </span>
                  <i
                    class="rili-top-left flex_center"
                    @click="YearNum++, Active(AvtiveValue, ActiveIndex)"
                  >
                    <svg
                      t="1726039944911"
                      class="icon iconright"
                      viewBox="0 0 1024 1024"
                      version="1.1"
                      xmlns="http://www.w3.org/2000/svg"
                      p-id="5834"
                      id="mx_n_1726039944912"
                    >
                      <path
                        d="M319 923c-6.4 0-12.8-2.4-17.7-7.3-9.8-9.8-9.8-25.6 0-35.4L669.6 512 301.3 143.7c-9.8-9.8-9.8-25.6 0-35.4 9.8-9.8 25.6-9.8 35.4 0l386 386c9.8 9.8 9.8 25.6 0 35.4l-386 386c-4.9 4.9-11.3 7.3-17.7 7.3z"
                        fill="#1A2332"
                        p-id="5835"
                      ></path>
                    </svg>
                  </i>
                </div>
                <div class="rili-bottom">
                  <ul class="flex_between_box">
                    <li
                      class="flex_between_box_li"
                      v-for="(item, index) in monthList"
                      :key="index"
                      :class="
                        ActiveIndex == index ? 'flex_between_box_li_active' : ''
                      "
                      @click="Active(item.value, index)"
                    >
                      {{ item.label }}
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="timeLine">
              <h3 class="LoginTime">{{ $t("MyAccount.RecentLogin") }}</h3>
              <el-timeline>
                <el-timeline-item
                  v-for="(activity, index) in activities"
                  :key="index"
                  :color="activity.color"
                  :size="activity.size"
                >
                  {{ activity.loginTime }}
                </el-timeline-item>
              </el-timeline>
            </div>
          </ul>
        </div>
      </div>
      <!-- 注销 后期放到computent里 -->
      <div class="DeleteAccount" v-else>
        <div class="DeleteAccount-top">
          <el-steps :active="steps" align-center space="20%">
            <el-step title="Notice and Agreement"></el-step>
            <el-step title="Resource Processing"></el-step>
            <el-step title="Cancellation Result"></el-step>
          </el-steps>
        </div>
        <div class="DeleteAccount-bottom margin-top10" v-if="steps == 1">
          <h2 class="DeleteAccount-head">
            Please carefully read the agreement in the following instructions
            and links
          </h2>
          <div class="DeleteAccount-content">
            <h3 class="">Important information for account cacellation</h3>
            <div class="DeleteAccount-body">
              Submitting an account cancellation application is an irreversible
              operation. To ensure the safety of your account and property, and
              to maintain normal public order, please confirm the following
              information before submitting your Alibaba Cloud<br />
              account cancellation request:<br />
              1. The person submitting the account cancellation request is
              either yourself or a legally authorized agent/representative of
              the account holder. In the latter case, the agent/representative
              shall inform the account holder of this notice and all documents
              related to the cancellation process, and ensure that they have
              understood and agreed to all the contents of the aforementioned
              documents.<br />
              2. The account you applied to cancel is in a stable and secure
              state (e.g. has not experienced any risks such as theft or being
              banned, and has not undergone any sensitive information changes
              such as changing passwords or changing phone bindings in the past
              three months)<br />
              3. You submitted an account cancellation application to us through
              a commonly used security device;<br />
              4. There are no unfulfilled contracts, outstanding fees, unpaid
              taxes, or other obligations that should be fulfilled according to
              laws and regulations under your account;<br />
              5. The binding relationship or external authorization between your
              account and other third-party network applications (such as
              websites, apps) has been terminated, or you can be confident that
              not terminating such binding relationship or not revoking such
              external authorization will not have any adverse effects on
              yourself or any third party;<br />
              6. All your data under your Alibaba Cloud account has been
              migrated and properly backed up, or you completely waive the right
              to retain or retrieve such data;<br />
              7. You are not submitting an account cancellation application to
              avoid ongoing or upcoming disputes or lawsuits, or to evade
              regulatory oversight from authorities, or to circumvent relevant
              laws and regulations.
            </div>
            <h3 class="">Reminder again</h3>
            <div class="DeleteAccount-body">
              Submitting an account cancellation application is an irreversible
              operation.<br />
              After account cancellation, you will no longer be able to log in
              to Alibaba Cloud websites, forums, or apps, access the control
              panel or cloud site control panel, or perform other operations
              that rely on account permissions.<br />
              Your personal information, transaction records, business data,
              historical information, etc. under this account will not be
              retrievable.<br />
              The system may automatically create cloud product service
              associated roles under your account for resource cleaning. For
              detailed instructions, please refer to "Account Cancellation -
              Account Cancellation".<br />
              If you wish to maintain any cloud services (including cloud sites)
              associated with this account and only wish to terminate some
              products/resources, please do not proceed with further actions.
            </div>
            <h3 class="">Confirm cancellation</h3>
            <div class="DeleteAccount-body">
              You are trying to cancel your Alibaba Cloud account. Please ensure
              that there are no valid transactions under the account and do not
              perform any operations during the account cancellation period to
              avoid cancellation failure.<br />
              After cancellation, you will no longer be able to use any Alibaba
              Cloud services, and your account and data will also be lost.
            </div>
            <div class="flex_center_start_box checkboxLabel">
              <el-checkbox
                v-model="checked"
                class="margin-right10"
              ></el-checkbox
              >I have understood the account cancellation agreement. After
              submitting the application, my account {{ Accountid }} will be
              cancelled, and the content, data, and services contained therein
              cannot be restored
            </div>
            <div style="display: flex">
              <el-button
                class="btn_blue flex_center btn_DelAccount"
                :class="checked ? '' : 'btn_eee'"
                :disabled="!checked"
                @click="
                  steps++;
                  NextCancellation();
                "
                >Next</el-button
              >
              <el-button
                class="btn_blue btn_eee flex_center btn_DelAccount"
                @click="DeleteAccount = true"
                >{{ $t("MyAccount.Cancel") }}</el-button
              >
            </div>
          </div>
        </div>
        <div class="DeleteAccount-bottom" v-if="steps == 2">
          <div v-if="step2One">
            <div class="DeleteAccount-step2-top">
              <h2 class="DeleteAccount-step2-head">
                <b style="color: #f56b6b">{{ yourUsagelist.length }}</b> item to
                be processed (of which
                <b style="color: #f56b6b">{{ yourUsagelistNored.length }}</b>
                results must be manually processed)
              </h2>
              <div class="DeleteAccount-body">
                It is recommended to handle the manual items first, and then
                recheck and confirm the cancellation before entering the account
                cancellation quiet period. The account cancellation is expected
                to be completed at 17:17 on July 22, 2024.
              </div>
            </div>
            <div class="DeleteAccount-step2-table">
              <div class="DeleteAccount-body">
                <el-table
                  :data="yourUsagelist"
                  style="width: 100%"
                  @selection-change="handleSelectionChange"
                  empty-text="No Data"
                >
                  <el-table-column
                    prop="Type"
                    :label="$t('Ownership.Type')"
                    align="center"
                  >
                    <template slot-scope="scope">
                      <span>{{ scope.row.type }}</span>
                    </template>
                  </el-table-column>

                  <el-table-column
                    prop="type"
                    label="Products/Services"
                    align="center"
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">
                      <span>{{ scope.row.type }}</span>
                    </template>
                  </el-table-column>
                  <el-table-column
                    prop="desc"
                    label="Description"
                    align="center"
                    show-overflow-tooltip
                  >
                  </el-table-column>
                  <el-table-column
                    prop=""
                    label="Operation"
                    align="center"
                    show-overflow-tooltip
                  >
                    <template slot-scope="scope">
                      <div>
                        <span
                          style="color: #1290c9"
                          @click="
                            DeleteAccount = true;
                            steps = 1;
                          "
                          >Go Handle It</span
                        >
                        <span
                          style="color: #1290c9"
                          class="margin-left30"
                          v-if="scope.row.type == 'may give up'"
                          @click="Operation(scope.row)"
                          >Give Up</span
                        >
                      </div>
                    </template>
                  </el-table-column>
                </el-table>
                <div style="display: flex" class="margin-top40">
                  <el-button
                    class="btn_blue flex_center btn_DelAccount"
                    @click="NextCancellation()"
                    >Recheck</el-button
                  >
                  <el-button
                    class="btn_blue flex_center btn_DelAccount"
                    @click="steps--"
                    >Back</el-button
                  >
                  <el-button
                    class="btn_blue btn_eee flex_center btn_DelAccount"
                    @click="DeleteAccount = true"
                    >{{ $t("MyAccount.Cancel") }}</el-button
                  >
                </div>
              </div>
            </div>
          </div>
          <div v-if="!step2One">
            <div class="step2One">
              <div>
                <img
                  class="imgCancel"
                  src="../../../assets//img/hudun.png"
                  alt=""
                />
              </div>
              <h2 class="step2One-head">Resource check passed!</h2>
              <h2 class="step2One-text">
                There are no resources to be processed for the current account.
                You can click on the bottom left corner to confirm the
                cancellation and proceed with the cancellation operation
              </h2>
              <div style="display: flex; justify-content: center">
                <el-button
                  class="btn_blue flex_center"
                  @click="
                    steps++;
                    cancelAccount();
                  "
                  >Confirm Cancellation</el-button
                >
                <el-button class="btn_blue flex_center" @click="steps--"
                  >Back</el-button
                >
                <el-button
                  class="btn_blue btn_eee flex_center btn_DelAccount"
                  @click="step2One = true"
                >
                  {{ $t("MyAccount.Cancel") }}</el-button
                >
              </div>
            </div>
          </div>
        </div>
        <div class="DeleteAccount-bottom" v-if="steps == 3">
          <div>
            <div class="step2One">
              <div>
                <img
                  class="imgCancel"
                  src="../../../assets//img/shizhong.png"
                  alt=""
                />
              </div>
              <h2 class="step2One-head">Cancelling in progress</h2>
              <h2 class="step2One-text">
                The system has entered the logout process, which may take some
                time. After the logout is completed, the logout result will be
                sent to your email. Please check your inbox carefully.
              </h2>
              <h2 class="step2One-text step2One-texttwo">
                Attention: Please do not operate the account during this period,
                otherwise it may result in cancellation failure or other
                uncontrollable consequences
              </h2>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      :visible.sync="ConfirmDialog"
      center
      :close-on-click-modal="true"
      @close="closeDialog"
      custom-class="dialog_normalsuo"
      :append-to-body="true"
    >
      <div>
        <div class="detail_cont margin-top20">
          <h3>Confirm Again</h3>
          <div class="cont_box margin-top20">
            <div class="detail_cont_text">
              1. After the instance is released,
              <span style="color: #f56b6b">it cannot be restored</span>: Please
              backup the relevant business data before confirming the release;
            </div>
            <div class="detail_cont_text margin-top20">
              2. After the balance is released,
              <span style="color: #f56b6b">it cannot be withdrawn</span>: If you
              need to withdraw, please withdraw separately and then cancel your
              account;
            </div>
            <div class="detail_cont_text margin-top20">
              3. Prepaid instances that have not yet expired
              <span style="color: #f56b6b">
                will be released directly without refund processing</span
              >:
              <br />
              If you need a refund, please go through the refund process
              separately before canceling your account.
            </div>
          </div>
        </div>
      </div>
      <div class="flex_center_star Confirmcheckbox margin-top20">
        <el-checkbox v-model="checkedTwo"></el-checkbox>I am fully aware of the
        risks and authorize the waiver of relevant rights and continue with
        account cancellation
      </div>
      <div class="flex_center margin-top30 ConfirmBtnbox">
        <!-- <el-button
          class="btn_export btn_exportCCC"
          @click="ConfirmDialog = false"
        >
          {{ $t("MyAccount.Cancel") }}</el-button
        > -->
        <el-button
          class="btn_export"
          :disabled="!checkedTwo"
          @click="onSubmitquxiao()"
          >Confirm</el-button
        >
      </div>
    </el-dialog>
    <el-dialog
      :visible.sync="DeleteDialog"
      center
      :close-on-click-modal="true"
      @close="DeleteDialog = false"
      custom-class="dialog_normalsuo"
      :append-to-body="true"
    >
      <div>
        <div class="detail_cont">
          <div class="flex_center margin-bottom20">
            <img
              class="imgDeleteGroup"
              src="../../../assets/dialogIcoImg/reporterrorIcon.png"
              alt=""
            />
          </div>
          <h3>Delete Group Account</h3>
          <div
            class="detail_cont_text"
            v-if="userType == 2"
            style="background-color: #fff"
          >
            Your account is a corporate user and your corporate user identity is
            already in use, so you cannot cancel the account. If you need to
            cancel your account, please contact your enterprise administrator.
            After deactivating your enterprise user identity, you can cancel
            your account.presentative.
          </div>
          <div
            class="detail_cont_text"
            v-if="userType == 3"
            style="background-color: #fff"
          >
            Your account is a corporate user with administrator status and
            cannot be cancelled. If you need to cancel, please contact your
            sales representative.
          </div>
        </div>
        <div class="flex_center margin-top30">
          <el-button class="btn_export" @click="DeleteDialog = false">
            Close</el-button
          >
        </div>
      </div>
    </el-dialog>
    <ReLogin :reLoginPop="reLoginVis"></ReLogin>
  </div>
</template>
<script>
import { mixins1 } from "@/mixins/index";
import crypto from "@/utils/crypto";
import { mapGetters, mapActions, mapState } from "vuex";
import { UploadImg, clearUserImage, getDashboard } from "@/api/userApi";
import {
  LoginOut,
  sendEmailCode,
  changePwd,
  giveUpTasksForCancelAccount,
  changeUserAccount,
  handleAccountOwnership,
  showTasksForCancelAccount,
  cancelAccount,
  showLoginHistoryDataByYM,
} from "@/api/api.js";
import { getoptions, getUserSimpleInfo } from "@/api/companyApi";
import ReLogin from "../../../components/ReLogin.vue";
export default {
  mixins: [mixins1],
  components: {
    ReLogin,
  },
  data() {
    return {
      reLoginVis: false,
      userinfo: JSON.parse(localStorage.getItem("userInfo")),
      value1: "",
      checked: false,
      steps: 1,
      CategoryVal: "",
      window: window,
      PasswordChange: false,
      IndicatorsValType: "",
      Edit: true,
      EditOne: true,
      EditTwo: true,
      DeleteAccount: true,
      ActiveIndex: new Date().getMonth(),
      AvtiveValue: new Date().getMonth() + 1,
      EditTree: true,
      password: JSON.parse(localStorage.getItem("userInfo")).userInfo
        .passwordHash,
      passwordtwo: "",
      passwordtree: "",
      radio: "1",
      text: [],
      imgedit: false,
      Accountid: JSON.parse(localStorage.getItem("userInfo")).userInfo.email,
      conInputType: "password", //查看密码
      averageLoginTime: "",
      lastLogDur: "",
      recentLoginTime: "",
      totalLogins: "",
      setTimeForFlag: true,
      setTimeFor: "",
      Emailcode: "",
      timerFor: null,
      ConfirmDialog: false,
      step2One: true,
      Selectable: [],
      checkedTwo: false,
      YearNum: new Date().getFullYear(),

      yourUsagelist: [],
      yourUsagelistNored: [],
      monthList: [
        {
          label: "Jan.",
          value: "01",
        },
        {
          label: "Feb.",
          value: "02",
        },
        {
          label: "Mar.",
          value: "03",
        },
        {
          label: "Apr.",
          value: "04",
        },
        {
          label: "May.",
          value: "05",
        },
        {
          label: "Jun.",
          value: "06",
        },
        {
          label: "Jul.",
          value: "07",
        },
        {
          label: "Aug.",
          value: "08",
        },
        {
          label: "Aep.",
          value: "09",
        },
        {
          label: "Oct.",
          value: "10",
        },
        {
          label: "Nov.",
          value: "11",
        },
        {
          label: "Dec.",
          value: "12",
        },
      ],
      activities: [],

      Enterprisecertification: {
        type: this.radio,
        firstName: "",
        lastName: "",
        phoneNumber: "",
        email: "",
        countryCode: "",
        address1: "",
        city: "",
        zipCode: "",
        companyName: "",
      },
      Peoplecertification: {
        type: this.radio,
        firstName: "",
        lastName: "",
        phoneNumber: "",
        email: "",
        countryCode: "",
        address1: "",
        city: "",
        zipCode: "",
        companyName: "",
      },
      giveUpid: [],
      provinceOptions: [],
      inputType: false, //查看密码
      inputTypetwo: false,
      inputTypetree: false,
      DeleteDialog: false,
      userType: 1,

      imageUrl:
        JSON.parse(localStorage.getItem("userInfo"))?.userInfo?.userImg == null
          ? ""
          : "https://www.csibizsearch.com/csi/usercenter/download/resource?resource=" +
            JSON.parse(localStorage.getItem("userInfo"))?.userInfo.userImg,
    };
  },
  computed: {
    ...mapGetters({
      token: "users/token",
    }),
    ...mapState({
      token: "users/token",
    }),
    type() {
      return this.inputType ? "text" : "password";
    },
    loginAndCreateDialog: {
      get() {
        return this.loginAndCreatePop;
      },
      set(newValue) {
        this.$emit("update:loginAndCreatePop", newValue);
      },
    },
  },
  beforeDestroy() {},
  destroyed() {},
  created() {
    this.imageUrl =
      JSON.parse(localStorage.getItem("userInfoImg")) == undefined
        ? this.imageUrl
        : JSON.parse(localStorage.getItem("userInfoImg"));
    this.$bus.$emit("changeImageUrl", this.imageUrl);
    this.getUserSimpleInfo();
  },
  mounted() {
    this.getCountry();
    this.password = crypto.decrypt(this.password);

    this.getDashboardList();

    this.Enterprisecertification = {
      type: this.radio,
      firstName: this.userinfo?.companyInfo?.firstName,
      lastName: this.userinfo?.companyInfo?.lastName,
      phoneNumber: this.userinfo?.companyInfo?.phoneNumber,
      email: this.userinfo?.companyInfo?.email,
      countryCode: this.userinfo?.companyInfo?.countryRegion,
      address1: this.userinfo?.companyInfo?.address,
      city: this.userinfo?.companyInfo?.city,
      zipCode: this.userinfo?.companyInfo?.zipCode,
      companyName: this.userinfo?.companyInfo?.companyName,
    };
  },

  methods: {
    getUserSimpleInfo() {
      getUserSimpleInfo().then((res) => {
        this.userType = res.data.userType;
        if (this.userType != 1) {
          this.radio = "2";
        }
        this.Peoplecertification = {
          type: this.radio,
          firstName: res.data?.userInfo?.firstName,
          lastName: res.data?.userInfo?.lastName,
          phoneNumber: res.data?.userInfo?.phoneNumber,
          email: res.data?.userInfo?.email,
          countryCode: res.data?.userInfo?.countryRegion,
          address1: res.data?.userInfo?.address,
          city: res.data?.userInfo?.city,
          zipCode: res.data?.userInfo?.zipCode,
          companyName: res.data?.userInfo?.companyName,
        };
      });
    },
    DeleteAccountedlog() {
      if (this.userType == 3 || this.userType == 2) {
        this.DeleteDialog = true;
      } else {
        this.DeleteAccount = false;
      }
    },
    ChangePassword() {
      crypto.encrypt(this.passwordtwo);

      let params = {
        originalPassword: crypto.encrypt(this.password),
        newPassword: crypto.encrypt(this.passwordtwo),
        confirmPassword: crypto.encrypt(this.passwordtree),
      };
      changePwd(params).then((res) => {
        if (res.code == 200) {
          this.$message({
            message: "Please Login in!",
            type: "error",
            duration: 3000,
          });
          sessionStorage.clear();
          setTimeout(() => {
            window.location.href = "/";
          }, 2000);
          localStorage.removeItem("token");
        } else {
          this.$message.error(res.msg);
        }
      });
    },

    Active(vaue, index) {
      this.ActiveIndex = index;
      this.AvtiveValue = vaue;
      showLoginHistoryDataByYM({
        dateStr: this.YearNum + "-" + vaue,
      }).then((res) => {
        this.activities = res.data;
        this.activities.map((item, index) => {
          item.color = "#1290C9";
        });
      });
    },
    cancelAccount() {
      cancelAccount().then((res) => {
        if (res.code == 200) {
          this.$message({
            message: res.msg,
            center: true,
            type: "success",
          });
        } else {
          this.$message({
            message: res.msg,
            center: true,
            type: "error",
          });
        }
      });
    },
    // Give Up
    Operation(row) {
      this.ConfirmDialog = true;
      this.giveUpid = row;
    },
    // 获取未处理事件结果
    NextCancellation() {
      showTasksForCancelAccount().then((res) => {
        if (res.code == 200) {
          this.yourUsagelist = res.data;
          this.yourUsagelistNored = res.data.filter(
            (item) => item.type != "may give up",
          );
          if (this.yourUsagelist.length == 0) {
            this.step2One = false;
          }
        } else {
          this.yourUsagelist = [];
        }
      });
    },
    onSubmitquxiao() {
      giveUpTasksForCancelAccount({ taskTypeId: this.giveUpid.id }).then(
        (res) => {
          this.$message({
            message: res.msg,
            center: true,
            type: "success",
          });
        },
      );
      this.ConfirmDialog = false;
      this.NextCancellation();
      if (this.yourUsagelist.length == 0) {
        this.step2One = false;
      }
    },
    closeDialog() {
      this.ConfirmDialog = false;
    },
    // 认证
    ChangeOwnership() {
      let params = {};
      if (this.radio == 2) {
        this.Enterprisecertification.type = this.radio;
        params = this.Enterprisecertification;
      } else {
        params = this.Peoplecertification;
      }

      handleAccountOwnership(params).then((res) => {
        if (res.code == -1) {
          this.$message({
            message: res.msg,
            center: true,
            type: "error",
          });
        } else {
          localStorage.setItem("renzheng", true);
          this.$message({
            message: res.msg,
            center: true,
            type: "success",
          });
        }
      });
    },
    //获取国家
    getCountry() {
      this.countryOptions = JSON.parse(
        localStorage.getItem("countryList"),
      )[0].countryList;
    },
    changeCountry() {
      this.Peoplecertification.city = "";
      this.Enterprisecertification.city = "";
      this.provinceOptions = [];
      if (
        this.Peoplecertification.countryCode ||
        this.Enterprisecertification.countryCode
      ) {
        this.getProvince();
      }
    },
    //获取省市
    async getProvince() {
      const params = {
        page: 1,
        pageSize: 10,
        company_country: this.Enterprisecertification.countryCode
          ? this.Enterprisecertification.countryCode
          : this.Peoplecertification.countryCode,
      };
      await getoptions(params).then((res) => {
        if (res && res.code) {
          let list =
            res.data.geographicalLocation.length > 0
              ? res.data.geographicalLocation[0].companyProvince
              : [];

          this.provinceOptions = list;
        }
      });
    },
    Deletapicture() {
      clearUserImage().then((res) => {
        this.$message({
          message: res.msg,
          center: true,
          type: "success",
        });
      });
      this.imageUrl = "";
      let userInfo = JSON.parse(localStorage.getItem("userInfo"));
      delete userInfo.userInfo.userImg;
      localStorage.setItem("userInfo", JSON.stringify(userInfo));
      localStorage.removeItem("userInfoImg");
      this.$bus.$emit("changeImageUrl", "");
      location.reload(true);
    },
    changepass() {
      this.EditTwo = !this.EditTwo;
      this.PasswordChange = false;
      this.passwordtree = "";
      this.passwordtwo = "";
      this.password = JSON.parse(
        localStorage.getItem("userInfo"),
      ).userInfo.passwordHash;
      this.password = crypto.decrypt(this.password);
    },
    // 认证
    Changauthentication() {
      this.EditTree = !this.EditTree;
    },
    // 发送验证码
    sendCodeForgot() {
      this.errFlagForSucess = false;
      this.errFlagForErr = false;
      if (this.Accountid == "") {
        return;
      }
      this.checkForgot();
    },
    //倒计时
    async checkForgot() {
      const params = {
        email: this.Accountid,
        source: "10",
      };
      const codeRes = await sendEmailCode(params);
      if (codeRes.code == 200) {
        if (!this.timerFor) {
          const time = 60;
          this.setTimeFor = time;
          this.setTimeForFlag = false;
          this.timerFor = setInterval(() => {
            if (this.setTimeFor > 1 && this.setTimeFor <= time) {
              this.setTimeFor--;
            } else {
              this.setTimeForFlag = true;
              clearInterval(this.timerFor);
              this.timerFor = null;
            }
          }, 1000);
        }

        this.$message({
          message: codeRes.msg,
          center: true,
          type: "success",
        });
        codeRes.msg;
      } else {
        this.$message({
          message: codeRes.msg,
          center: true,
          type: "error",
        });
      }
    },
    getDashboardList() {
      getDashboard()
        .then((res) => {
          if (res.code == 200) {
            this.activities = res.data.rows;
            this.activities.map((item, index) => {
              item.color = "#1290C9";
            });
            this.totalLogins = res.data.totalLogins;
            this.averageLoginTime = res.data.averageLoginTime;
            this.lastLogDur = res.data.lastLogDur;
            this.recentLoginTime = res.data.recentLoginTime;
          }
        })
        .catch((err) => {
          this.reLoginVis = String(err).includes("403");
        });
    },
    SubmitLoginOut() {
      LoginOut({}).then((res) => {
        if (res.code == "200") {
          this.$message({
            message: res.msg,
            center: true,
            type: "success",
          });

          localStorage.removeItem("token");
          localStorage.removeItem("renzheng");
          localStorage.removeItem("userInfo");
          localStorage.removeItem("userInfoImg");
          localStorage.removeItem("dataCleaningField");
          location.reload();
          // window.location.href = "/";
        } else {
          sessionStorage.clear();
          localStorage.removeItem("token");
          localStorage.removeItem("renzheng");
          localStorage.removeItem("userInfo");
          localStorage.removeItem("dataCleaningField");
          location.reload();
          // window.location.href = "/";
          localStorage.removeItem("userInfoImg");
        }
      });
    },
    ChangeAccount() {
      this.EditOne = !this.EditOne;
      this.Accountid = JSON.parse(
        localStorage.getItem("userInfo"),
      ).userInfo.email;
      this.Emailcode = "";
    },
    // 修改 Account ID
    ChangeAccountid() {
      changeUserAccount({
        email: this.Accountid,
        verificationCode: this.Emailcode,
      }).then((res) => {
        if (res.code == 200) {
          this.Accountid = res.data;
          this.$message({
            message: res.msg,
            center: true,
            type: "success",
          });
          sessionStorage.clear();
          setTimeout(() => {
            window.location.href = "/";
          }, 3000);
          localStorage.removeItem("token");
          sessionStorage.removeItem("token");
          sessionStorage.removeItem("menuItem");
        } else {
          this.$message({
            message: res.msg,
            center: true,
            type: "error",
          });
        }
      });
    },
    handlePictureCardPreview(file) {
      this.imageUrl = file.url;
    },
    handleAvatarSuccess(res, file) {},
    imgchange(file) {
      const reader = new FileReader();

      reader.onload = (event) => {
        const binaryData = event.target.result; // 获取二进制数据

        const formData = new FormData();
        formData.append("avatarfile", new Blob([binaryData]), file.name);

        UploadImg(formData).then((res) => {
          if (res.code == 200) {
            this.imageUrl =
              "https://www.csibizsearch.com/csi/usercenter/download/resource?resource=" +
              res.data;
            localStorage.setItem("userInfoImg", JSON.stringify(this.imageUrl));
            location.reload();
            // 更新 localStorage
          } else {
            this.$message.error(res.msg);
          }
        });
      };

      reader.readAsArrayBuffer(file.raw); // 启动读取
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg";
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG) {
        this.$message.error(
          "Uploading avatar images can only be in JPG format!",
        );
      }
      if (!isLt2M) {
        this.$message.error(
          "Uploading avatar images can only be in JPG format!",
        );
      }

      return isJPG && isLt2M;
    },
    handleSelectionChange(val) {
      this.Selectable = val;
    },
  },
};
</script>
<style scoped>
.flex_center_between_box {
  display: flex;
  justify-content: space-between;
}

.sel_box {
  width: 40%;
  min-width: 530px;
  position: relative;
}

.sel_box /deep/ .el-input__inner {
  height: 50px !important;
  line-height: 50px !important;
  border-color: #ccc !important;
  border-radius: 10px;
  font-size: 20px;
  padding-left: 10px !important;
  color: #1a2332;
}
.sel_box /deep/ .el-input__inner::placeholder {
  color: #cccccc;
}

.sel_box h4 {
  font-size: 24px;
  font-family: "Arial Bold";
  color: #1a2332;
  line-height: 28px;
  margin-bottom: 10px;
}
.rili-top span {
  font-family: "Arial Bold" !important;
}

/deep/ .el-table {
  margin-top: 30px;
}
/deep/ .el-table .el-table__cell {
  padding: 0 !important;
}
/deep/ .el-table th.el-table__cell {
  height: 50px !important;
}

/deep/ .el-table th.el-table__cell > .cell {
  font-family: "Arial Bold";
  font-size: 18px;
}
/deep/ .el-table td.el-table__cell {
  height: 60px !important;
}
/deep/ .el-table td.el-table__cell > .cell {
  font-family: "Arial";
  font-size: 18px;
}

.information-content {
  display: flex;
}

.btn_eee {
  background: #eee !important;
  color: #1a2332;
}

.account-left-right {
  margin-left: 20px;
}

.account-left-right h3 {
  font-size: 30px;
  color: #1a2332;
  line-height: 36px;
}

.account-left {
  margin-bottom: 30px;
}

.account-left-right h4 {
  font-size: 20px;
  color: #1290c9;
  line-height: 24px;
  margin-top: 6px;
}

.account-left-right .account-left-right-time {
  font-size: 16px;
  color: #666666;
  font-family: ArialMT;
}

.avatar-uploader /deep/ .el-upload {
  cursor: pointer;
  position: relative;
  overflow: hidden;
  border: none;
}
.avatar-uploader .el-upload:hover {
  border: none !important;
}

.avatar {
  height: 120px;
  width: 120px;
  line-height: 120px;
  border-radius: 50%;
  display: block;
}

.avatartex {
  width: 120px;
  height: 120px;
  background: #f5f5f5;
  font-size: 60px;
  color: #a2a9b0;
  text-align: center;
}
.account-left-box {
  padding-bottom: 30px;
  border-bottom: 1px solid #dddddd;
}

.content-center {
  margin-top: 30px;
}

.AccountOwnership {
  font-size: 20px;
}

.ul-tab {
  display: flex;
  justify-content: space-around;
}

.ul-tab-title {
  font-size: 18px;
  font-weight: normal;
  color: #8497ab;
}

.ul-tab-text {
  font-size: 20px;
  font-weight: normal;
  color: #1a2332;
  margin-top: 12px;
}

/deep/ .el-timeline-item__wrapper {
  top: -2px;
  position: relative;
  padding-right: 35px;
}
/deep/ .el-radio {
  margin-right: 60px;
}

/deep/ .el-radio__label {
  font-size: 20px;
  color: #1a2332;
}

.postiverelatibve {
  position: relative;
  overflow: hidden;
}

.postiveaboust {
  position: absolute;
}

/deep/ .el-timeline {
  height: 439px;
  overflow-y: scroll;
  overflow-x: initial;
  padding-right: 24px;
}

/deep/ .el-timeline-item__tail {
  right: 7px;
  left: auto;
}

/deep/ .el-timeline-item__node--normal {
  width: 8px;
  height: 8px;
  right: 4px;
  top: 2px;
  left: auto;
}

.LoginTime {
  font-size: 18px;
  color: #1a2332;
  margin-bottom: 20px;
  font-family: "Arial Bold";
  text-align: center;
}
/deep/ .el-timeline-item {
  padding-bottom: 22px;
}
/deep/ .el-timeline-item__content {
  font-size: 18px;
  color: #1a2332;
}
.ul-tab-left {
  width: 510px;
  margin-right: 60px;
}

.send_time {
  font-size: 20px;
  line-height: 30px;
  color: #1290c9;
  position: absolute;
  right: 40px;
  top: 10px;
}

.send_txt {
  font-size: 20px;
  color: #1290c9;
  line-height: 30px;
  position: absolute;
  right: 10px;
  text-align: center;
  border-left: 1px solid #ccc;
  padding-left: 10px;
  top: 10px;
  text-decoration: none;
  cursor: pointer;
}

.el-select-dropdown__item {
  font-size: 20px !important;
  color: #1a2332;
}

.ul-tab-left-rili {
  background: #f5f5f5;
  border-radius: 24px;
  padding: 30px 15px 40px 15px;
  text-align: center;
}

.rili-top {
  font-size: 20px;
  color: #1a2332;
  width: 346px;
  height: 50px;
  margin: auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #ffffff;
  border-radius: 25px;
  padding: 4px 6px;
}

.rili-top-left {
  width: 42px;
  height: 42px;
  border-radius: 50%;
  background: #f5f5f5;
}
.iconleft {
  width: 20px;
  height: 20px;
  position: relative;
  right: 2px;
}
.iconright {
  width: 20px;
  height: 20px;
  position: relative;
  left: 2px;
}
.iconrili {
  width: 20px;
  height: 20px;
  position: relative;
  top: 2px;
  right: 5px;
}

.flex_between_box_li {
  margin-top: 30px;
  width: 90px;
  height: 90px;
  padding: 20px 17px;
  margin-left: 15px;
  margin-right: 15px;
  background: #ffffff;
  border-radius: 24px;
  font-size: 20px;
  font-family: "Arial Bold";
  line-height: 50px;
}

.flex_between_box_li_active {
  color: #1290c9;
  border: 1px solid #1290c9;
}

.flex_between_box {
  flex-wrap: wrap;
}

.DeleteAccount-top {
  padding: 16px;
  background: #ffffff;
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.12);
  border-radius: 4px;
}

.el-steps {
  justify-content: center;
}

/deep/ .el-step__icon {
  width: 44px;
  height: 44px;
  background: #1290c9;
  background: #f5f5f5;
  color: #a2a9b0;
}

/deep/ .el-step__icon.is-text {
  border: none;
  color: #a2a9b0;
}

/deep/ .el-step__icon-inner {
  font-size: 24px;
  font-weight: normal;
}

/deep/.el-step__title.is-process {
  font-size: 16px;
  color: #a2a9b0;
  font-weight: normal;
}
/deep/.el-step__title.is-wait {
  font-size: 16px;
  font-weight: normal;
}

/deep/ .el-step__title.is-finish {
  font-size: 16px;
  font-weight: normal;
  color: #1290c9;
}

/deep/ .el-step.is-center .el-step__line {
  top: 50%;
}

/deep/ .is-finish .is-text {
  color: #ffffff !important;
  background: #1290c9 !important;
}

.DeleteAccount-bottom {
  padding: 30px 40px;
  background: #ffffff;
  box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.12);
  border-radius: 4px;
  color: #1a2332;
}

.DeleteAccount-head {
  font-size: 24px;
  color: #1a2332;
  line-height: 28px;
  height: 30px;
  text-align: center;
}

.DeleteAccount-content h3 {
  margin-top: 40px;
  margin-bottom: 20px;
  font-size: 18px;
  line-height: 22px;
  font-weight: bold;
}

.DeleteAccount-body {
  font-size: 18px;
  color: #1a2332;
  line-height: 34px;
}
.checkboxLabel {
  margin: 40px 0px;
  font-size: 18px;
  color: #1a2332;
  line-height: 34px;
}

/deep/ .el-checkbox__input.is-checked + .el-checkbox__label {
  color: #1a2332;
}

/deep/ .el-checkbox__input.is-checked .el-checkbox__inner {
  background: #1290c9 !important;
}
.btn_DelAccount {
  min-width: 180px !important;
  height: 40px !important;
}

.DeleteAccount-step2-head {
  font-size: 18px;
  font-weight: bold;
  line-height: 22px;
  color: #1a2332;
  margin-bottom: 20px;
}

.DeleteAccount-step2-top {
  background: #f5f5f5;
  border-radius: 4px;
  padding: 20px;
}

.Confirmcheckbox {
  font-size: 18px;
  color: #1a2332;
  line-height: 28px;
}
.Confirmcheckbox .el-checkbox {
  margin-right: 10px;
}

.step2One {
  width: 65%;
  margin: auto;
  text-align: center;
  padding: 30px 0px;
}
.imgCancel {
  width: 80px;
  height: 80px;
}

.step2One-head {
  margin-top: 20px;
  margin-bottom: 30px;
  font-size: 24px;
  font-weight: bold;
  color: #1a2332;
  line-height: 28px;
  text-align: center;
}

.step2One-text {
  font-size: 18px;
  color: #1a2332;
  line-height: 34px;
  margin-bottom: 40px;
}

.step2One-texttwo {
  color: #f56b6b;
}
/deep/ .el-step__head.is-finish {
  color: #fff;
  border-color: #eeeeee;
}
/deep/ .el-step__line {
  color: #fff;
  background-color: #eeeeee;
}

.icon_watchun {
  background-image: url("../../../assets/img/watch_ic1.png");
}

.icon_watchon {
  background-image: url("../../../assets/img/watch_ic2.png");
}

.edit_con {
  position: absolute;
  right: 12px;
  bottom: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 40px;
  height: 40px;
  background: rgba(153, 153, 153, 0.3);
  border-radius: 50%;
}

.edit_con .edit_con_icon {
  width: 30px;
  height: 30px;
}

.account_base {
  width: 340px;
}

.role_company {
  padding-left: 30px;
  border-left: 1px solid #dddddd;
}
.del_btn,
.logout_btn {
  width: max-content;
  min-width: 180px;
  border-radius: 10px;
}
.account_form_item {
  align-items: center;
  margin-bottom: 0 !important;
}

.account_form_itemA {
  align-items: center;
  margin-top: 16px !important;
  margin-bottom: 0 !important;
}
.his_sel_box .information-content {
  justify-content: flex-start;
  gap: 40px;
}
.box2 {
  margin-top: 10px;
  padding: 14px 0px;
}
.cont_box {
  padding: 16px;
  border-radius: 6px;
  background: #f5f5f5;
}
.detail_cont_text {
  font-size: 18px;
  line-height: 28px;
  padding: 0 !important;
}
.ConfirmBtnbox {
  gap: 40px;
}
.btn_export {
  width: 210px;
  height: 50px;
  font-size: 18px;
  border-radius: 10px;
  padding: 0 !important;
  margin: 0 !important;
}
.imgDeleteGroup {
  width: 60px;
  height: 60px;
}
.margin-right20 {
  margin-right: 20px;
}

@media screen and (max-width: 1920px) {
  .account-left-box {
    padding-bottom: 22px;
  }
  .account-left {
    margin-bottom: 22px;
  }
  .avatar {
    height: 90px;
    width: 90px;
    line-height: 90px;
  }

  .avatartex {
    width: 90px;
    height: 90px;
    font-size: 45px;
  }
  .edit_con {
    right: 9px;
    bottom: 7px;
    width: 30px;
    height: 30px;
  }
  .edit_con .edit_con_icon {
    width: 22px;
    height: 22px;
  }
  .account_base {
    width: 255px;
  }
  .account-left-right {
    margin-left: 15px;
  }
  .account-left-right h3 {
    font-size: 22px;
    line-height: 27px;
  }
  .account-left {
    margin-bottom: 22px;
  }
  .account-left-right h4 {
    font-size: 16px;
    line-height: 18px;
    margin-top: 5px;
  }
  .account-left-right .account-left-right-time {
    font-size: 14px;
  }
  .role_company {
    padding-left: 22px;
  }
  .del_btn,
  .logout_btn {
    min-width: 135px;
    border-radius: 7px;
  }
  .content-center {
    margin-top: 22px;
  }
  .sel_box {
    min-width: 400px;
  }

  .sel_box /deep/ .el-input__inner {
    height: 36px !important;
    line-height: 36px !important;
    border-radius: 7px;
    font-size: 16px;
  }

  .sel_box h4 {
    font-size: 20px;
    line-height: 22px;
  }
  .account_form_itemA {
    margin-top: 12px !important;
  }
  .send_txt {
    font-size: 16px;
    line-height: 20px;
    right: 8px;
    padding-left: 8px;
    top: 8px;
  }
  .send_time {
    font-size: 16px;
    line-height: 20px;
    right: 30px;
    top: 8px;
  }
  .AccountOwnership {
    font-size: 16px;
  }
  /deep/ .el-radio {
    margin-right: 45px;
  }
  /deep/ .el-radio__label {
    font-size: 16px;
  }
  .his_sel_box .information-content {
    gap: 30px;
  }
  .box2 {
    margin-top: 7px;
    padding: 10px 0px;
  }
  .ul-tab-title {
    font-size: 16px;
  }

  .ul-tab-text {
    font-size: 16px;
    margin-top: 9px;
  }
  .ul-tab-left {
    width: 384px;
    margin-right: 45px;
  }
  .el-select-dropdown__item {
    font-size: 16px !important;
  }

  .LoginTime {
    font-size: 16px;
    margin-bottom: 15px;
  }

  /deep/ .el-timeline {
    height: 325px;
    padding-right: 18px;
  }
  /deep/ .el-timeline-item__tail {
    right: 6px;
    left: auto;
  }
  /deep/ .el-timeline-item__node--normal {
    width: 6px;
    height: 6px;
    right: 4px;
    top: 3px;
    left: auto;
  }
  /deep/ .el-timeline-item__wrapper {
    top: -2px;
    padding-right: 26px;
  }
  /deep/ .el-timeline-item {
    padding-bottom: 14px;
  }
  /deep/ .el-timeline-item__content {
    font-size: 16px;
  }

  .ul-tab-left-rili {
    border-radius: 18px;
    padding: 22px 12px 30px 12px;
  }
  .rili-top {
    font-size: 16px;
    width: 260px;
    height: 36px;
    border-radius: 18px;
    padding: 3px 5px;
  }
  .rili-top-left {
    width: 32px;
    height: 32px;
  }
  .iconleft {
    width: 16px;
    height: 16px;
    position: relative;
    right: 1px;
  }
  .iconright {
    width: 16px;
    height: 16px;
    position: relative;
    left: 1px;
  }
  .iconrili {
    width: 16px;
    height: 16px;
    position: relative;
    top: 2px;
    right: 5px;
  }
  .flex_between_box_li {
    margin-top: 22px;
    width: 68px;
    height: 68px;
    padding: 15px 13px;
    margin-left: 11px;
    margin-right: 11px;
    border-radius: 18px;
    font-size: 16px;
    line-height: 38px;
  }
  .DeleteAccount-top {
    padding: 12px;
  }
  /deep/ .el-step__icon {
    width: 34px;
    height: 34px;
  }

  /deep/ .el-step__icon-inner {
    font-size: 18px;
  }
  /deep/.el-step__title.is-process,
  /deep/.el-step__title.is-wait,
  /deep/ .el-step__title.is-finish {
    font-size: 14px;
  }
  .DeleteAccount-bottom {
    padding: 22px 30px;
  }

  .DeleteAccount-head {
    font-size: 20px;
    line-height: 22px;
    height: 22px;
  }
  .DeleteAccount-content h3 {
    margin-top: 30px;
    margin-bottom: 15px;
    font-size: 16px;
    line-height: 20px;
  }

  .DeleteAccount-body {
    font-size: 16px;
    line-height: 26px;
  }

  .checkboxLabel {
    margin: 30px 0px;
    font-size: 16px;
    line-height: 26px;
  }
  .btn_DelAccount {
    min-width: 136px !important;
    height: 36px !important;
  }
  .DeleteAccount-step2-head {
    font-size: 16px;
    line-height: 20px;
    margin-bottom: 15px;
  }

  .DeleteAccount-step2-top {
    padding: 15px;
  }
  /deep/ .el-table th.el-table__cell {
    height: 44px !important;
  }

  /deep/ .el-table th.el-table__cell > .cell {
    font-size: 16px;
  }
  /deep/ .el-table td.el-table__cell {
    height: 50px !important;
  }
  /deep/ .el-table td.el-table__cell > .cell {
    font-size: 16px;
  }
  .step2One {
    padding: 22px 0px;
  }
  .imgCancel {
    width: 60px;
    height: 60px;
  }
  .step2One-head {
    margin-top: 15px;
    margin-bottom: 22px;
    font-size: 20px;
    line-height: 24px;
  }

  .step2One-text {
    font-size: 16px;
    line-height: 26px;
    margin-bottom: 30px;
  }
  .cont_box {
    padding: 12px;
  }
  .Confirmcheckbox,
  .detail_cont_text {
    font-size: 16px;
    line-height: 24px;
  }
  .ConfirmBtnbox {
    gap: 30px;
  }
  .btn_export {
    width: 160px;
    height: 36px;
    font-size: 16px;
    border-radius: 5px;
  }
  .imgDeleteGroup {
    width: 45px;
    height: 45px;
  }
  .margin-right20 {
    margin-right: 15px;
  }
}
@media screen and (max-width: 1441px) {
  .account-left-box {
    padding-bottom: 20px;
  }
  .account-left {
    margin-bottom: 20px;
  }
  .avatar {
    height: 80px;
    width: 80px;
    line-height: 80px;
  }
  .avatartex {
    width: 80px;
    height: 80px;
    font-size: 40px;
  }
  .edit_con {
    right: 8px;
    bottom: 6px;
    width: 27px;
    height: 27px;
  }
  .edit_con .edit_con_icon {
    width: 20px;
    height: 20px;
  }
  .account_base {
    width: 228px;
  }
  .account-left-right {
    margin-left: 12px;
  }
  .account-left-right h3 {
    font-size: 20px;
    line-height: 24px;
  }
  .account-left {
    margin-bottom: 20px;
  }
  .account-left-right h4 {
    font-size: 14px;
    line-height: 16px;
    margin-top: 4px;
  }
  .account-left-right .account-left-right-time {
    font-size: 12px;
  }
  .role_company {
    padding-left: 20px;
  }
  .del_btn,
  .logout_btn {
    min-width: 120px;
    border-radius: 6px;
  }
  .content-center {
    margin-top: 20px;
  }
  .sel_box {
    min-width: 360px;
  }

  .sel_box /deep/ .el-input__inner {
    height: 32px !important;
    line-height: 32px !important;
    border-radius: 6px;
    font-size: 14px;
  }

  .sel_box h4 {
    font-size: 16px;
    line-height: 18px;
  }
  .account_form_itemA {
    margin-top: 10px !important;
  }
  .send_txt {
    font-size: 14px;
    line-height: 18px;
    right: 7px;
    padding-left: 7px;
    top: 7px;
  }
  .send_time {
    font-size: 14px;
    line-height: 18px;
    right: 26px;
    top: 7px;
  }
  .AccountOwnership {
    font-size: 14px;
  }
  /deep/ .el-radio {
    margin-right: 40px;
  }
  /deep/ .el-radio__label {
    font-size: 14px;
  }
  .his_sel_box .information-content {
    gap: 26px;
  }
  .box2 {
    margin-top: 6px;
    padding: 8px 0px;
  }
  .ul-tab-title {
    font-size: 14px;
  }

  .ul-tab-text {
    font-size: 14px;
    margin-top: 8px;
  }
  .ul-tab-left {
    width: 340px;
    margin-right: 40px;
  }
  .ul-tab-left-rili {
    border-radius: 16px;
    padding: 20px 10px 26px 10px;
  }
  .rili-top {
    font-size: 16px;
    width: 232px;
    height: 32px;
    border-radius: 16px;
    padding: 3px 4px;
  }
  .rili-top-left {
    width: 28px;
    height: 28px;
  }
  .flex_between_box_li {
    margin-top: 20px;
    width: 60px;
    height: 60px;
    padding: 12px 11px;
    margin-left: 10px;
    margin-right: 10px;
    border-radius: 16px;
    font-size: 14px;
    line-height: 36px;
  }

  .LoginTime {
    margin-bottom: 12px;
  }

  /deep/ .el-timeline {
    height: 288px;
    padding-right: 16px;
  }
  /deep/ .el-timeline-item__tail {
    right: 6px;
    left: auto;
  }
  /deep/ .el-timeline-item__node--normal {
    width: 6px;
    height: 6px;
    right: 4px;
    top: 3px;
    left: auto;
  }
  /deep/ .el-timeline-item__wrapper {
    top: -2px;
    padding-right: 24px;
  }
  /deep/ .el-timeline-item {
    padding-bottom: 12px;
  }
  /deep/ .el-timeline-item__content {
    font-size: 14px;
  }
  .DeleteAccount-top {
    padding: 10px;
  }
  /deep/ .el-step__icon {
    width: 30px;
    height: 30px;
  }

  /deep/ .el-step__icon-inner {
    font-size: 16px;
  }

  /deep/.el-step__title.is-process,
  /deep/.el-step__title.is-wait,
  /deep/ .el-step__title.is-finish {
    font-size: 14px;
  }
  .DeleteAccount-bottom {
    padding: 20px 26px;
  }

  .DeleteAccount-head {
    font-size: 18px;
    line-height: 22px;
    height: 22px;
  }
  .DeleteAccount-content h3 {
    margin-top: 26px;
    margin-bottom: 14px;
    font-size: 14px;
    line-height: 18px;
  }

  .DeleteAccount-body {
    font-size: 14px;
    line-height: 22px;
  }

  .checkboxLabel {
    margin: 26px 0px;
    font-size: 14px;
    line-height: 22px;
  }
  .btn_DelAccount {
    min-width: 120px !important;
    height: 32px !important;
  }
  .DeleteAccount-step2-head {
    font-size: 14px;
    line-height: 18px;
    margin-bottom: 12px;
  }

  .DeleteAccount-step2-top {
    padding: 12px;
  }
  /deep/ .el-table th.el-table__cell {
    height: 32px !important;
  }
  /deep/ .el-table th.el-table__cell > .cell {
    font-size: 14px;
  }
  /deep/ .el-table td.el-table__cell {
    height: 40px !important;
  }
  /deep/ .el-table td.el-table__cell > .cell {
    font-size: 14px;
  }
  .step2One {
    padding: 20px 0px;
  }
  .imgCancel {
    width: 54px;
    height: 54px;
  }
  .step2One-head {
    margin-top: 12px;
    margin-bottom: 20px;
    font-size: 18px;
    line-height: 20px;
  }

  .step2One-text {
    font-size: 14px;
    line-height: 22px;
    margin-bottom: 26px;
  }
  .cont_box {
    padding: 10px;
  }
  .Confirmcheckbox,
  .detail_cont_text {
    font-size: 14px;
    line-height: 20px;
  }
  .ConfirmBtnbox {
    gap: 26px;
  }
  .btn_export {
    width: 140px;
    height: 32px;
    font-size: 14px;
  }
  .imgDeleteGroup {
    width: 40px;
    height: 40px;
  }
}
</style>
